/**
 * 本文の右下に置く「全て読む」。
 *
 * **背景を塗らないこと。** 以前は本文の右下に absolute で重ねて不透明な四角を敷いており、
 * 面が透明・半透明・グラデの場所（プロフィール配下は全部そう）で四角が浮いていた。
 * しかも塗る色が #121212 / #1e1e1e / #171717 と3種類に割れていた。
 *
 * 代わりに最終行へ float で流す。位置は右下のままで、文字と重ならないので隠す必要がない。
 * 最終行に入りきらないときだけ、下に1行落ちて右端に付く。
 *
 * 差し込みは `formatReviewText(text, isMobile, <ここ>)`。
 * 各行が <p> なので、呼び出し側で後ろに並べるとブロックで改行される。
 */
export const READ_MORE_SX = {
  float: 'right',
  ml: 1,
  cursor: 'pointer',
  color: 'primary.main',
  fontSize: '0.7rem',
  fontWeight: 'normal',
  lineHeight: 1.5,
  whiteSpace: 'nowrap',
} as const;
